import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'FAQ',
  name: 'faqBlock',
  type: 'object',
  fields: [
    defineField({
      title: 'Content',
      name: 'content',
      type: 'faq',
    }),
    defineField({
      title: 'Link',
      name: 'link',
      type: 'link',
    }),
  ],
  preview: {
    select: {
      title: 'content.title',
    },
    prepare({ title }) {
      return {
        title: `${title}` || 'Untitled',
        subtitle: 'FAQ',
      }
    },
  },
})